/**
 * MeasurementEquipment Create Page
 * Page for creating new measurement equipment
 *
 * @version 2025.1.0
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';
import { PageShell } from '../../components';
import { measurementEquipmentService } from '../../services/measurementEquipmentService';
import { MeasurementEquipmentFormData } from '../../types/measurementEquipment';
import { MeasurementEquipmentForm } from './components/MeasurementEquipmentForm';

export const MeasurementEquipmentCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: MeasurementEquipmentFormData) => {
    try {
      setLoading(true);
      setError(null);
      await measurementEquipmentService.createMeasurementEquipment(data);
      navigate('/measurement-equipments');
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'Erro ao criar equipamento de medição';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/measurement-equipments');
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Equipamentos de Medição', path: '/measurement-equipments' },
        { label: 'Novo Equipamento' },
      ]}
      title="Cadastrar Novo Equipamento de Medição"
      subtitle="Preencha os dados do equipamento de medição e calibração"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <MeasurementEquipmentForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        loading={loading}
      />
    </PageShell>
  );
};

export default MeasurementEquipmentCreatePage;
